'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdDirectionsWalk = function MdDirectionsWalk(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm16.3 14.8l-4.7 23.6h3.6l3-13.4 3.4 3.4v10h3.4v-12.5l-3.5-3.4 1-5c2.2 2.5 5.5 4.1 9.1 4.1v-3.2c-3.2 0-5.7-1.8-7.1-4.1l-1.7-2.7c-0.7-1-1.6-1.6-2.8-1.6-0.5 0-0.9 0.2-1.3 0.2l-8.7 3.6v7.8h3.4v-5.6l2.9-1.2z m6.2-5.7c-1.8 0-3.4-1.4-3.4-3.2s1.6-3.4 3.4-3.4 3.4 1.6 3.4 3.4-1.6 3.2-3.4 3.2z' })
        )
    );
};

exports.default = MdDirectionsWalk;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/directions-walk.js
// module id = 2250
// module chunks = 0